// @noflow
import { fromJS } from 'immutable';
import { curry, range } from 'lodash/fp';

export const toSeq = x => x.toSeq();
export const sortBy = curry((predicate, collection) => collection.sortBy(predicate));
export const map = curry((predicate, collection) => collection.map(predicate));
export const get = curry((key, item) => item.get(key));
export const getIn = curry((key, item) => item.getIn(key));
export const merge = curry((dest, src) => dest.merge(src));
export const filter = curry((predicate, collection) => collection.filter(predicate));
export const includes = curry((collection, item) => collection.includes(item));
export const find = curry((predicate, collection) => collection.find(predicate));
export const toJS = collection => collection.toJS();
export const pick = curry((props, map) => props.reduce((agg, prop) => agg.set(prop, map.get(prop)), fromJS({})));
/**
 * getListAsChunks : Takes an Immutable List and return it in a new list as chunks.
 * @param  { Immutable.List } An Immutable List that will be separated into chunks
 * @param  { int } The size of each chunk
 * @return { Immutable.List } An Immutable List with the original list broken into chunks
 * i.e.
 * const myList = fromJS([
 * 	{ name: 'foo' },
 * 	{ name: 'bar' },
 * 	{ name: 'fooBar' },
 * 	{ name: 'barFoo'},
 * ]);
 * const chunkedList = getListAsChunks(myList, 2);
 * //  List(
 * 		[ { name: 'foo' }, { name: 'bar' } ],
 * 		[ { name: 'fooBar' }, { name: 'barFoo'} ]
 * 	 );
 */
export function getListAsChunks(list, chunkSize) {
    const iterations = Math.ceil(list.count() / chunkSize);

    return range(0, iterations).reduce((all, item, i) => {
        const start = i * chunkSize;
        const end = (i + 1) * chunkSize;
        return all.push(list.slice(start, end));
    }, fromJS([]));
}



// WEBPACK FOOTER //
// ./src/core/utils/immutable.js